import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App'
import store from './store'
import router from './router'
import './init'

Vue.use(VueMeta)

const app = new Vue({
  store,
  router,
  components: { App },
  template: '<App/>'
})

// mounting an SSR app on the client assumes
// the HTML was pre-rendered and will perform
// hydration instead of mounting new DOM nodes.
app.$mount('#app')



// WEBPACK FOOTER //
// ./src/front/main.js